module.exports = {
  "title": "generating link...",
  "no_link": "Links? What links?.",
  "actions": {
    "get_link": "Get Link",
    "manage_links": "Manage Links"
  },
  "personalized_link": {
    "title": "Personalized Link",
    "sub_text": "Who's the lucky prospect? Create a special link for them.",
    "placeholder": "Enter recipient email here"
  },
  "anonymous_link": {
    "title": "Anonymous Link",
    "sub_text": "Use this link for a quick share. User level tracking is not available for this link."
  },
  "campaign_link": {
    "title": "Executing a new campaign?",
    "sub_text": "Enter name and/or more information to generate a UTM link to this asset for a campaign.",
    "placeholder": "Enter campaign tag here"
  },
  "generated_link": {
    "title": "Here's your link",
    "copied": "Copied",
    "actions": {
      "delete_link": "Delete link",
      "copy_link": "Copy link"
    },
    "confirmation":{
      "title" : "Are you sure you want to delete this asset link?",
      "description": "Once deleted, recipients won't be able to access the {entityType} through this link anymore."
    }
  },
  "advanced_settings": {
    "title": "Advanced Settings",
    "options": {
      "download": "Allow recipients to download",
      "editable": "Editable",
      "read_only": "Read Only",
      "info": "This applies to PPTs, Docs, Google Slides and Google Docs.",
      "reshare": "Allow recipients to reshare",
      "engage": "Enable engage",
      "password": {
        "title": "Set a password",
        "placeholder": "Enter password",
        "change_password": "Change password"
      },
      "expiry": "Set an expiry date & time",
      "nda": {
        "title": "Enable NDA",
        "heading": "NDA templates",
        "empty_message": {
          "title": "Type less, Share more",
          "description": "Create reusable NDA templates for you and your teams."
        },
        "actions": {
          "create": "Create New NDA Template"
        }
      },
      "email_gating": {
        "title": "Enable email gating",
        "options": {
          "otp": "Validate with OTP",
          "work": "Validate work email",
          "domains": "Allow users from select domains",
          "tool_tip": "This feature helps restrict access to this content by users from select organizations (email domains) only."
        }
      },
      "change": "Change",
      "utm": {
        "title": "Add additional UTM parameters",
        "campaign_source": "Campaign Source",
        "campaign_medium": "Campaign Medium",
        "campaign_term": "Campaign Term",
        "campaign_content": "Campaign Content",
        "example": "Example",
        "paid_keywords": "Identify the paid keywords",
        "ads_content": "Used to differentiate ads",
        "marketing": "Marketing",
        "cpc": "CPC",
        "banner": "Banner",
        "email": "Email"
      }
    }
  },
  "error_messages": {
    "no_recipient": "We don't see a recipient in the 'To' field. Add an email id. tes",
    "no_subject": "We don't see a subject in the 'Subject' field. Add a Subject.",
    "no_assets": "You need to attach some content for us to send your email.",
    "invalid_password": "Please enter a valid password",
    "invalid_expiryDate": "Please select a valid date",
    "expiryDate_range": "Expiry date should be greater than current date",
    "invalid_domain": "Please enter a valid domain",
  }
}